/**
 * Root path for all dashboard pages.
 */
export const DASHBOARD_BASE = "/manage";

/**
 * Helper to build section base paths
 * @example buildBase("admin") // "/manage/admin"
 */
export const buildBase = (section: string): string =>
  `${DASHBOARD_BASE}/${section}`;
